export const customerDetail = {
    name: "John",
    email: "john@gmail.com",
    orderId: 1234567
};